import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { spliceOutWhere } from 'components/sharpr/util/spliceOut';

export function SettingsElasticSearchLanguagesRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsElasticSearchLanguages', {
		url: '/admin/elasticsearch/languages',
		controllerAs: 'vm',
		controller: SettingsElasticSearchLanguagesCtrl,
		templateUrl: '/ng/hub/Settings/ElasticSearch/Languages/SettingsElasticSearchLanguagesCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'ElasticSearch Hub Languages',
			readyToImport: ApiResourcify.endpoint('/nosql/imports/ready'),
		},
	});
}

export class SettingsElasticSearchLanguagesCtrl {
	constructor($filter, $timeout, Api, Identity, Pubnub, readyToImport) {
		'ngInject';
		// save injections
		this.$timeout = $timeout;
		this.Api = Api;
		this.readyToImport = readyToImport;
		// setup
		this.listenForProgress(Pubnub);
		this.isSuperadmin = Identity.hasMultipleHubs();
		this.shDurationHuman = $filter('shDurationHuman');
		this.shDate = $filter('shDate');
		this.setupImportsTable();
	}

	kickoffImport(hub) {
		this.Api.post('/nosql/imports', { hub_id: hub.id }, { 'Submit-As-Job': true });
		hub.hasStarted = true;
	}

	transformImports(imports) {
		imports.data.forEach(imp => {
			imp.hub = this.isSuperadmin ? `${imp.account} › ${imp.hub}` : imp.hub;
			if (imp.client_id === 0) {
				imp.hub = '(All other hubs)';
			}
			if (imp.success === true) {
				imp.status = 'Complete';
			} else if (imp.success === false) {
				imp.status = 'Failed';
			} else if (imp.started_at) {
				imp.status = 'In Progress';
			}
			imp.started_at = this.shDate(imp.started_at, 'long');
			imp.exe_time = this.shDurationHuman(imp.exe_time);
			if (imp.num_total > 0) {
				imp.progress = `${imp.num_complete}/${imp.num_total}`;
			} else {
				imp.progress = 'calculating...';
			}
		});
		this.imports = imports.data;
		return imports;
	}

	setupImportsTable() {
		this.importsTable = {
			columns: [
				{ field: 'model', label: 'Model', sortable: true },
				{ field: 'hub', label: 'Hub', sortable: true },
				{ field: 'language', label: 'Language', sortable: true },
				{ field: 'started_at', label: 'Started At', sortable: true },
				{ field: 'exe_time', label: 'Took', sortable: true },
				{ field: 'progress', label: 'Progress', sortable: false },
				{ field: 'status', label: 'Status', sortable: false },
			],
			transformer: this.transformImports.bind(this),
			endpoint: '/nosql/imports/started',
			limit: 10,
			filters: {},
			defaultSort: '-started_at',
			bindUrl: 'imports',
		};
	}

	listenForProgress(Pubnub) {
		Pubnub.getChannel('es-imports').subscribe(payload => {
			console.log('progress!', payload);
			this.$timeout(() => {
				let isKnownImport = false;
				this.imports.forEach(imp => {
					if (payload.model == imp.model && payload.language == imp.language && payload.index == imp.index) {
						imp.progress = `${payload.done}/${payload.total}`;
						isKnownImport = true;
					}
				});
				console.log('isKnownImport?', isKnownImport);
				console.log('imports', this.imports);
				if (!isKnownImport) {
					this.importsTable.filters.cb = Math.random().toString(36).slice(2, 8);
					spliceOutWhere(this.readyToImport, { id: payload.client_id });
				}
			});
		});
	}
}
